import { keepPreviousData, useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export enum BookkeepingStatus {
  NOT_PURCHASED = 'NOT_PURCHASED',
  ONBOARDING = 'ONBOARDING',
  BOOKKEEPING_PAUSED = 'BOOKKEEPING_PAUSED',
  ACTIVE = 'ACTIVE',
  UNKNOWN = 'unknown',
}

export const BOOKKEEPING_STATUS_LABELS: Record<BookkeepingStatus, string> = {
  [BookkeepingStatus.NOT_PURCHASED]: 'Not purchased',
  [BookkeepingStatus.ONBOARDING]: 'Onboarding',
  [BookkeepingStatus.BOOKKEEPING_PAUSED]: 'Paused',
  [BookkeepingStatus.ACTIVE]: 'Active',
  [BookkeepingStatus.UNKNOWN]: 'Unknown',
}

export interface BookkeeperCustomer {
  id: string
  legalName: string
  dotNumber: string
  phoneNumber: string
  bookkeepingStatus: BookkeepingStatus | ''
  users: { name: string; email: string }[]
}

interface BookkeeperCustomerPage {
  count: number
  next: string | null
  previous: string | null
  results: BookkeeperCustomer[]
}

export function useBookkeeperCustomers(page: number, search: string, status: string) {
  const { data, isLoading, isFetching, isError, refetch } = useQuery({
    queryKey: [CacheKeys.BOOKKEEPER_CUSTOMERS, page, search, status],
    queryFn: () =>
      axios
        .get('/api/v1/insure/internal/bookkeeper-customers/', {
          params: { page, search: search || undefined, status: status || undefined },
        })
        .then((response) => toCamelCase(response.data) as BookkeeperCustomerPage),
    placeholderData: keepPreviousData,
  })
  return {
    customers: data?.results ?? [],
    count: data?.count ?? 0,
    hasNextPage: !!data?.next,
    hasPreviousPage: !!data?.previous,
    isLoading,
    isFetching,
    isError,
    refetch,
  }
}
